/**
 * Attendance marks, mirrored from AttendanceStatuses on the server.
 *
 * "Not reported" is not one of the server's values — an unmarked session simply has no status. It
 * gets a number here so the calendar filter can offer it as a choice alongside the other two.
 */
export const ATTENDANCE_ATTENDED = 1;
export const ATTENDANCE_MISSED = 2;

/** Filter-only: the session has no attendance recorded against it. */
export const ATTENDANCE_NOT_REPORTED = 0;

export interface AttendanceFilterOption {
  value: number;
  labelKey: string;
  fallback: string;
  icon: string;
}

export const ATTENDANCE_FILTER_OPTIONS: AttendanceFilterOption[] = [
  { value: ATTENDANCE_ATTENDED, labelKey: "ATTENDANCE_ATTENDED", fallback: "הגיע", icon: "✓" },
  { value: ATTENDANCE_MISSED, labelKey: "ATTENDANCE_MISSED", fallback: "לא הגיע", icon: "✕" },
  {
    value: ATTENDANCE_NOT_REPORTED,
    labelKey: "ATTENDANCE_NOT_REPORTED",
    fallback: "לא דווח",
    icon: "—",
  },
];

/** Does this appointment's mark match the selected filter values? */
export function matchesAttendanceFilter(
  attendanceStatusId: number | null | undefined,
  selected: number[] | undefined
): boolean {
  if (!selected || selected.length === 0) return true;

  return selected.includes(attendanceStatusId ?? ATTENDANCE_NOT_REPORTED);
}
